module.exports = __webpack_public_path__ + "img/pto.5bca2ba5.svg";